import React from 'react'
import ManagerHardware from './ManagerHardware'
import OperationHardware from './OperationHardware'
import { useDispatch } from 'react-redux'
import { fetchHardwareDescriptions } from '../../../../../store/slices/hardwareDescriptionSlice'
import { getAllAutoSaveWorkentries } from '../../../../../store/slices/autosaveSlice'
import { fetchHardware } from '../../../../../store/slices/hardwareSlice'
import { fetchDescriptionTasks } from '../../../../../store/slices/DescriptionTask'

const HardwareParent = ({
  setSelectedActions,
  opemail,
  handleAddRowManagerEdit,
  selectedemail,
  selectedServiceType,
  managerOPID,
  managerOPProject,
  row,
  Action,
  setAction,
  hardwareAction,
  setHardwareAction,
  employees,
  tasks,
  items,
  hardwareData,
  handlerefresh,
  taskTableRowId,
  entries,
  autosaveentries,
  sourceName,
  handleAddRow,
  totalHours,
  handleRemoveRow,
  isLoadingtask,
  showprojectDetails,
  managerViewEmpTask
}) => {
  const dispatch = useDispatch()

  const handlerefreshagain = React.useCallback(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
  }, [dispatch]);

  return (
    <div>
      {taskTableRowId === row?._id ? (
        showprojectDetails && (
          <ManagerHardware
            handlerehardfresh={handlerefreshagain}
            handlerefreshagain={handlerefreshagain}
            hardwareData={hardwareData}
            employees={employees}
            entries={entries}
            tasks={tasks}
            items={items}
            row={row}
            Action={Action}
            setAction={setAction}
            hardwareAction={hardwareAction}
            setHardwareAction={setHardwareAction}
            handlerefresh={handlerefresh}
            taskTableRowId={taskTableRowId}
          />
        )
      ) : (
        <div className=" w-60 h-full"></div>
      )}

      {taskTableRowId === row?._id ? (
        managerViewEmpTask && (
          <OperationHardware
            setSelectedActions={setSelectedActions}
            handleAddRowManagerEdit={handleAddRowManagerEdit}
            selectedemail={selectedemail}
            selectedServiceType={selectedServiceType}
            managerOPID={managerOPID}
            opemail={opemail}
            managerOPProject={managerOPProject}
            handlerehardfresh={handlerefreshagain}
            handlerefreshagain={handlerefreshagain}
            handlerefresh={handlerefresh}
            autosaveentries={autosaveentries}
            hardwareData={hardwareData}
            employees={employees}
            entries={entries}
            tasks={tasks}
            items={items}
            sourceName={sourceName}
            totalHours={totalHours}
            handleAddRow={handleAddRow}
            handleRemoveRow={handleRemoveRow}
            isLoadingtask={isLoadingtask}
            row={row}
            Action={Action}
            setAction={setAction}
            hardwareAction={hardwareAction}
            setHardwareAction={setHardwareAction}
            taskTableRowId={taskTableRowId}
          />
        )
      ) : (
        <div className=" w-60 h-full"></div>
      )}
    </div>
  )
}

export default HardwareParent
